import React, { Component } from "react";

class PrivacyPolicy extends Component {
  render() {
    return (
      <div>
        <div className="Background-color-nav" />
        <div className="PrivacyPolicy">
          <p>Privacy Policy</p> <br />
          <p>Updated October 1, 2025</p>
          <br />
          <br />
          <p>
            This Privacy Policy (this "Policy") provides information about the
            information that JetSweat Inc. ("JetSweat" or "We") may collect from
            users of the mobile software application that JetSweat makes
            available for download (individually and collectively, the "App"),
            the related website located at www.jetsweatfitness.com and any other
            online properties owned or controlled by or on behalf of JetSweat
            (collectively with the App, the "Service"), and how we use, protect,
            and share such information.
          </p>
          <br />
          <p>
            By using the Service, you agree to the terms of this Policy. We are
            committed to protecting your privacy and complying with applicable
            privacy frameworks, including the AICPA Trust Services Criteria for
            Privacy (SOC 2 Privacy) and the Health Insurance Portability and
            Accountability Act of 1996 ("HIPAA").
          </p>
          <br />
          <p>
            We may change this Policy from time to time, and changes are
            effective upon posting. Please review this Policy regularly. Your
            continued use of the Service after changes are posted constitutes
            your agreement to the changes. If you do not agree to the terms of
            this Policy, please discontinue your use of the Service.
          </p>
          <br />
          <br />
          <p>1. Information Collection</p>
          <br />
          <p>
            Each time you provide or transmit information to us via the Service,
            JetSweat may obtain and collect personally identifiable information
            about you, including but not limited to your name, email address, and
            any other information that may be used to identify you. For example,
            and without limitation, we may collect such information from you when
            you create a user account on the Apps or when you contact our staff.
          </p>
          <br />
          <p>
            We may also collect non-personally identifiable information from you.
            Non-personally identifiable information is data that is not used to
            specifically identify, contact, or locate an individual, including
            but not limited to zip code, gender, age, or IP address.
          </p>
          <br />
          <p>
            We only collect personal information that is relevant and necessary
            for the specified purposes of delivering our services, in accordance
            with the principle of data minimization.
          </p>
          <br />
          <br />
          <p>2. Information Use</p>
          <br />
          <p>
            We may use the information we collect from and about you for any of
            the following purposes:
          </p>
          <ul style={{ paddingLeft: "30px", paddingTop: "15px" }}>
            <li>
              To fulfill your requests for classes or other products or services;
            </li>
            <br />
            <li>To respond to your inquiries;</li>
            <br />
            <li>To review Service usage and operations;</li>
            <br />
            <li>
              To address problems with the Service, our business, or our
              services;
            </li>
            <br />
            <li>
              To protect the security or integrity of the Service and our
              business;
            </li>
            <br />
            <li>
              To monitor the Service for compliance with our End User License
              Agreement and Terms of Service ("Terms of Use") and the law;
            </li>
            <br />
            <li>To help improve our services; and</li>
            <br />
            <li>
              To contact you with updates and other informational and promotional
              materials from us or trusted third-party partners.
            </li>
          </ul>
          <br />
          <p>
            We will not use your personal information for purposes other than
            those stated without first obtaining your explicit consent.
          </p>
          <br />
          <br />
          <p>3. Information Sharing</p>
          <br />
          <p>
            We may disclose information collected from and about you as follows:
          </p>
          <ul style={{ paddingLeft: "30px", paddingTop: "15px" }}>
            <li>
              To our related companies and service providers, to perform a
              business, professional or technical support function for us;
            </li>
            <br />
            <li>
              To our marketing partners, advertisers or other third parties, who
              may contact you with their own offers;
            </li>
            <br />
            <li>
              As necessary if we believe there has been a violation of our Terms
              of Use or of our rights or the rights of any third party;
            </li>
            <br />
            <li>
              To respond to legal process (such as a search warrant, subpoena or
              court order) and provide information to law enforcement agencies or
              in connection with an investigation on matters related to public
              safety, as permitted by law, or otherwise as required by law;
            </li>
            <br />
            <li>
              In the event that our company or substantially all of its assets
              are acquired, your personal information may be one of the
              transferred assets.
            </li>
          </ul>
          <br />
          <p>
            We will only share personal information with third parties under
            contractual agreements that require them to comply with equivalent
            privacy and security obligations, including confidentiality and data
            protection safeguards.
          </p>
          <br />
          <p>We do not sell your personal data.</p>
          <br />
          <p>
            We may also disclose your personal information with your express
            consent. We may share aggregate, non-personally identifiable
            information about Service users with third parties.
          </p>
          <br />
          <br />
          <p>4. Interest-Based Advertising</p>
          <br />
          <p>
            We may partner with ad networks and other ad serving providers
            ("Advertising Providers") who serve ads on behalf of us and others
            on non-affiliated websites or mobile applications. Some of those ads
            may be personalized, meaning that they are intended to be relevant
            to you based on information Advertising Providers collect about your
            visits to this site and elsewhere over time.
          </p>
          <br />
          <p>
            You may visit www.aboutads.info to learn more about this type of
            advertising and how to opt-out of this form of advertising by
            companies participating in the Digital Advertising Alliance ("DAA")
            self-regulatory program.
          </p>
          <br />
          <p>
            You may also contact us directly to limit data used for
            interest-based advertising, where applicable.
          </p>
          <br />
          <p>
            Note that electing to opt out will not stop advertising from
            appearing in your browser or applications. It may make the ads you
            see less relevant to your interests. In addition, note that if you
            use a different browser or erase cookies from your browser, you may
            need to renew your opt-out choice.
          </p>
          <br />
          <br />
          <p>5. Children</p>
          <br />
          <p>
            Our Service is not directed to children under 13. We will never
            knowingly collect any personally identifiable information about
            children under the age of 13.
          </p>
          <br />
          <p>
            If we discover that we have collected information from a child in
            violation of applicable laws, we will take immediate steps to delete
            that information.
          </p>
          <br />
          <br />
          <p>6. Apple Health Information</p>
          <br />
          <p>
            In order to provide our services, such as recommending video content
            you may enjoy, we may read and/or write data to the Apple Health
            database on your Apple device with your consent.
          </p>
          <br />
          <p>
            We will request your explicit, revocable consent before accessing
            Apple Health data, and we will only use this data for the purposes
            outlined at the time of consent.
          </p>
          <br />
          <p>
            We will not use this information for marketing or advertising
            purposes or share it with third parties.
          </p>
          <br />
          <p>
            Health data obtained from Apple Health may be considered PHI under
            HIPAA. We treat all such data with the same level of protection and
            care required under HIPAA guidelines.
          </p>
          <br />
          <br />
          <p>7. California Privacy Rights</p>
          <br />
          <p>
            Under California's "Shine the Light" law, we provide a method for
            consumers to "opt-out" of having their information shared with third
            parties. Contact us at support@jetsweatfitness.com to unsubscribe.
          </p>
          <br />
          <p>
            Additionally, under the California Consumer Privacy Act (CCPA), if
            applicable, you have the right to request access to or deletion of
            your personal information, as well as the right to know what
            categories of information we collect and disclose.
          </p>
          <br />
          <p>
            You may submit a request by emailing support@jetsweatfitness.com.
          </p>
          <br />
          <br />
          <p>8. Data Retention and Deletion</p>
          <br />
          <p>
            At any time, you may request that we remove a posting made to our
            Services or deactivate your account, if you have an account with us,
            by contacting us at support@jetsweatfitness.com or writing to us at
            16 Esterbrook Road, Wainscott, NY 11975.
          </p>
          <br />
          <p>
            We retain personal data only for as long as necessary to fulfill the
            purposes for which it was collected or as required by law. Upon
            request or upon account termination, we will securely delete or
            anonymize your data, except where retention is legally required.
          </p>
          <br />
          <p>
            While all personally identifiable information (PII) will be deleted
            upon request, anonymized or aggregated data (i.e. video views) may
            be retained for business purposes like analytics. The viewing data
            will be linked to an anonymous user ID, not the user's personal
            details.
          </p>
          <br />
          <br />
          <p>9. Security</p>
          <br />
          <p>
            We take appropriate, commercially reasonable physical, electronic,
            and administrative security measures to help safeguard personal
            information from unauthorized access, alteration, or disclosure.
          </p>
          <br />
          <p>
            These measures include access controls, encryption, logging, and
            security awareness training. We also maintain a formal incident
            response plan in the event of a data breach.
          </p>
          <br />
          <p>
            Even though we follow reasonable procedures to try to protect the
            information in our possession, no security system is perfect and we
            cannot promise, and you should not expect, that your information will
            be secure in all circumstances.
          </p>
          <br />
          <p>
            We implement safeguards required by HIPAA, including administrative,
            physical, and technical measures, to ensure the confidentiality,
            integrity, and availability of PHI.
          </p>
          <br />
          <br />
          <p>10. User Rights</p>
          <br />
          <p>
            You have the following rights regarding your personal information
            (subject to applicable laws):
          </p>
          <ul style={{ paddingLeft: "30px", paddingTop: "15px" }}>
            <li>The right to access your personal data</li>
            <br />
            <li>The right to correct or update inaccurate information</li>
            <br />
            <li>The right to request deletion of your data</li>
            <br />
            <li>
              The right to restrict or object to certain data processing
              activities
            </li>
            <br />
            <li>The right to data portability</li>
            <br />
            <li>
              The right to withdraw consent at any time (where processing is
              based on consent)
            </li>
          </ul>
          <br />
          <p>
            You may exercise these rights by contacting us at
            support@jetsweatfitness.com.
          </p>
          <br />
          <br />
          <p>11. Contact Us</p>
          <br />
          <p>
            If you have any questions regarding this Policy or our privacy
            practices, contact us at: support@jetsweatfitness.com
          </p>
          <br />
          <br />
          <p>12. HIPAA Privacy Policies and Procedures</p>
          <br />
          <p>
            1. Purpose. This document summarizes the permitted uses and
            disclosures of patient protected health information ("PHI") as
            permitted by the Health Insurance Portability and Accountability Act
            of 1996 ("HIPAA") Standards for Privacy of Individually Identifiable
            Health Information (the "Privacy Rule" or the "HIPAA Privacy Rule"),
            as amended by the Health Information Technology for Economic and
            Clinical Health Act, which is at Section 13400, et seq. of the
            American Recovery and Reinvestment Act of 2009, 42 U.S.C. § 17921,
            et seq., (the "HITECH Act") and any regulations promulgated
            thereunder, including the HIPAA omnibus final rule (the "HIPAA Final
            Rule").
          </p>
          <br />
          <p>2. Scope. This policy applies to all Company staff members.</p>
          <br />
          <p>
            3. Privacy Policy Statement. The Company is committed to complying
            with the Privacy Rule.
          </p>
          <br />
          <p>
            The Company recognizes the need to protect the privacy of PHI in
            order to facilitate the effective delivery of health care. These
            Privacy Policies and Procedures are designed and intended to ensure
            the Company's compliance with the Privacy Rule. The Company adopts
            these Policies and Procedures to protect the PHI that it creates and
            maintains from unauthorized use, disclosure, or access, and to
            maintain the confidentiality and integrity of that PHI. These
            Policies and Procedures also ensure that individuals have rights
            related to their PHI. Through the Company's Notice of Privacy
            Practices ("Privacy Notice") individuals are informed of the
            Company's legal duties and these Policies and Procedures, as well as
            their individual rights with respect to their PHI.
          </p>
          <br />
          <p>4. Key Definitions.</p>
          <br />
          <ul style={{ paddingLeft: "30px", paddingTop: "15px" }}>
            <li>
              Protected Health Information (PHI): Information that (1) identifies
              (or could be reasonably used to identify) an individual, (2) is
              created or received by a HIPAA covered entity (a health care
              provider, health plan or health care clearinghouse) and (3) relates
              to the past, present or future physical or mental health of the
              individual, the provision of health care to the individual, or the
              past, present or future payment for the provision of health care to
              the individual.
            </li>
            <br />
            <li>
              Business Associate: A person or entity, other than a member of a
              covered entity's workforce, that creates, receives, maintains or
              transmits PHI on behalf of a covered entity for a function or
              activity regulated by HIPAA. The HIPAA Final Rule expands the
              definition of "business associate" to include subcontractors to a
              business associate that create, receive, maintain or transmit PHI
              on behalf of a business associate. Business associate functions or
              activities on behalf of a covered entity include claims processing
              or administration, data analysis, processing or administration,
              utilization review, quality assurance, billing, benefit management,
              practice management and repricing.
            </li>
          </ul>
          <br />
          <p>
            5. Amendments and Updates. These Policies and Procedures will be
            amended and/or supplemented as necessary and appropriate to comply
            with changes in the law or regulations or other interpretation of the
            Company's privacy-related obligations, or to reflect changes related
            to the Company. The Company will document and implement changes to
            these Policies and Procedures whenever there is a change in the law,
            regulations or interpretation of the Company's privacy obligations
            and/or a material change to the uses or disclosures of PHI or other
            privacy practices that necessitate a change in these Policies and
            Procedures. If a change requires revisions to the Privacy Notice, the
            Company will not implement the change before the effective date of
            the revised Privacy Notice unless the Privacy Officer deems it
            necessary to apply the change to PHI that the Company created or
            received before this effective date.
          </p>
          <br />
          <p>
            6. Breach Notification. If there is a breach of unsecured PHI, the
            Company will notify affected individuals without unreasonable delay
            and no later than 60 days from discovery, in accordance with the
            HIPAA Breach Notification Rule.
          </p>
          <br />
          <p>
            7. Minimum Necessary Disclosure. The Company will only use or
            disclose the minimum necessary PHI to accomplish the intended purpose
            of the use, disclosure, or request.
          </p>
          <br />
          <p>
            These Policies and Procedures are effective as of October 1, 2025.
          </p>
          <br />
          <br />
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;
